export default {
    props: {
        // 分享链接地址，不填则使用当前页面地址
        share: {
            type: String,
            default: '',
        },
        // 本条数据的主键
        rowguid: {
            type: String,
            default: '',
        },
        // 本条数据的类型（文章、文件等）
        type: {
            type: String,
            default: '',
        },
    },
    computed: {
        // 点赞数据
        likedinfo() {
            return this.data.likedinfo || {};
        },
        //收藏数据
        collectinfo() {
            return this.data.collectinfo || {};
        },
    },
    methods: {
        likeHandler() {
            var url = '';

            if (this.likedinfo.isoperated) {
                // 已点过赞，本次操作应取消点赞

                url = `${this.$store.state.api.webUrl}/liked/off.json`;
            } else {
                // 未点过赞，本次操作应点赞
                url = `${this.$store.state.api.webUrl}/liked/on.json`;
            }

            this.$post(url, {
                objectguid: this.rowguid,
                objecttype: this.type,
            }, data => {
                this.data.likedinfo = data;

                this.$emit('like', data.isoperated);
            });
        },
        collectHandler() {
            var url = '';

            if (this.collectinfo.isoperated) {
                // 已收藏，本次操作应取消收藏

                url = `${this.$store.state.api.webUrl}/collect/off.json`;
            } else {
                // 未收藏，本次操作应收藏
                url = `${this.$store.state.api.webUrl}/collect/on.json`;
            }

            this.$post(url, {
                objectguid: this.rowguid,
                objecttype: this.type,
            }, data => {
                this.data.collectinfo = data;

                this.$emit('collect', data.isoperated);
            });
        },
        shareHandler(type){
            if(type=='question'){
                this.$emit('share', data.isoperated);
            }
        }
    },
    mounted() {
        
    }
};